import { Region } from '../Shared/Region';
import { EffectTypes } from '../../Enums/EffectTypes';
import { BaseEffect } from './BaseEffect';
import { type VisualCompElement } from '../../types';

export class DropShadowEffect extends BaseEffect {
    static type = EffectTypes.DROPSHADOW;

    static getRegionOfDefinition(region: Region, compElement: VisualCompElement) {
        return new Region(
            Number.NEGATIVE_INFINITY,
            Number.NEGATIVE_INFINITY,
            Number.POSITIVE_INFINITY,
            Number.POSITIVE_INFINITY,
        );
    }

    static getRegionOfInterest(region: Region, compElement: VisualCompElement) {
        if (compElement.dropShadow && compElement.dropShadow.state === 'ENABLE') {
            const ds = compElement.dropShadow;
            const blurRadius = ds.blurRadius * 2;
            region = new Region(
                Math.min(region.left, region.left + ds.offsetX - blurRadius),
                Math.min(region.top, region.top + ds.offsetY - blurRadius),
                Math.max(region.right, region.right + ds.offsetX + blurRadius),
                Math.max(region.bottom, region.bottom + ds.offsetY + blurRadius),
            );
            return region;
        }

        return region;
    }
}
